import a from "../../../@babel/runtime/helpers/esm/slicedToArray2.mjs";
import f from "../../../@babel/runtime/helpers/esm/objectSpread22.mjs";
import * as e from "react";
function v() {
  var t = f({}, e);
  return t.useId;
}
var s = 0, o = v();
const d = o ? (
  // Use React `useId`
  function(t) {
    var r = o();
    return t || (process.env.NODE_ENV === "test" ? "test-id" : r);
  }
) : (
  // Use compatible of `useId`
  function(t) {
    var r = e.useState("ssr-id"), n = a(r, 2), u = n[0], i = n[1];
    return e.useEffect(function() {
      var c = s;
      s += 1, i("rc_unique_".concat(c));
    }, []), t || (process.env.NODE_ENV === "test" ? "test-id" : u);
  }
);
export {
  d as default
};
//# sourceMappingURL=useId.mjs.map
